import useRecording from '@app/hooks/recordings/useRecording';
import { useEffect, useMemo } from 'react';

export type InteractionAudioProps = {
    id: string;
    url: string;
};

export const InteractionAudio = ({ id, url }: InteractionAudioProps) => {
    const { data: recordingResponse } = useRecording({ id }, { enabled: Boolean(url) });
    const recordingBlob = recordingResponse?.blob ?? null;

    const audioSrc = useMemo(
        () => (recordingBlob ? URL.createObjectURL(recordingBlob) : undefined),
        [recordingBlob]
    );

    useEffect(() => {
        return () => {
            if (audioSrc) URL.revokeObjectURL(audioSrc);
        };
    }, [audioSrc]);

    return (
        <audio
            src={audioSrc}
            title={recordingResponse?.filename || url}
            controls
            style={{ width: '100%' }}
        />
    );
};

export default InteractionAudio;
